import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { SIZES } from './consts';
import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

export const statuses = [
  'none', // nothing has happened yet
  'initializing', // task is initializing (file is yet to be uploaded)
  'upload', // upload is in progress
  'inProgress', // task is in progress
  'success', // has successful artifact.
  'error', // has failed
] as const;

export type NodeStatus = typeof statuses[number];

const statusStyles = {
  success: {
    background: '#0F9960',
    icon: 'check-circle',
    label: 'Complete',
  },
  error: {
    background: '#DB3737',
    icon: 'circle-xmark',
    label: 'Error',
  },
  inProgress: {
    background: '#D9822B',
    icon: 'spinner',
    label: 'In Progress',
  },
  initializing: {
    background: '#D9822B',
    icon: 'spinner',
    label: 'Initializing...',
  },
  upload: {
    background: '#D9822B',
    icon: 'spinner',
    label: 'Uploading..',
  },
  none: {
    background: '#737373',
    icon: 'circle',
    label: '',
  },
};

export const NodeStatusIndicator = ({ status }: { status: NodeStatus }) => {
  const styles = statusStyles[status];

  return (
    <Flex
      height="100%"
      padding="7px 12px"
      background={styles.background}
      borderRadius="7px"
      display="inline-flex"
      alignItems="center"
      gap={SIZES.gapSmall}
      color="white"
    >
      <FaIcon icon={styles.icon} />
      <Text size={SIZES.textSmall}>{styles.label}</Text>
    </Flex>
  );
};
